<template>
  <div>
    <TopHeader />
    <section class="container-fluid uc-bg">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link :to="{ name: 'PersonalStudy' }" class="item"
                >个人中心</router-link
              >
              <router-link to="" class="item">基本信息</router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- vueCropper 剪裁图片实现-->
      <el-dialog
        title="上传头像"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        append-to-body
      >
        <div class="cropper-content">
          <div class="cropper" style="text-align:center">
            <vueCropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="option.info"
              :full="option.full"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
              :centerBox="option.centerBox"
              :infoTrue="option.infoTrue"
              :fixedBox="option.fixedBox"
              :high="option.high"
              @realTime="realTime"
              @imgLoad="imgLoad"
            ></vueCropper>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="finish('blob')" :loading="loading"
            >确认上传</el-button
          >
        </div>
      </el-dialog>

      <div class="uc-userEdit">
        <div class="container bg-white">
          <div class="row">
            <div class="col-24">
              <div class="tabHeader">
                <div
                  :class="tab == 'tab1' ? 'item on' : 'item'"
                  @click="tab = 'tab1'"
                >
                  个人资料
                </div>
                <div
                  :class="tab == 'tab2' ? 'item on' : 'item'"
                  @click="tab = 'tab2'"
                >
                  安全设置
                </div>
              </div>
            </div>
          </div>

          <!-- 个人资料 -->
          <div class="row" v-show="tab == 'tab1'">
            <div class="col-24">
              <div class="form">
                <div class="user-box">
                  <div class="face">
                    <img
                      :src="headImg"
                      :alt="$store.getters.user.first_name"
                      onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
                    />
                  </div>
                  <el-upload
                    action=""
                    accept="image/png, image/jpeg"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="changeUpload"
                  >
                    <h3>更换头像（2M以内）</h3>
                  </el-upload>
                </div>
                <div class="title">基本信息</div>
                <el-form :model="form" ref="form" :rules="rules">
                  <div class="list">
                    <div class="item">
                      <div class="txt">姓名</div>
                      <div class="con">
                        <span class="uc-w100">{{
                          $store.getters.user.first_name
                        }}</span>
                      </div>
                    </div>
                    <div class="item">
                      <div class="txt">所属部门</div>
                      <div class="con">
                        {{ $store.getters.user.org_name }}
                      </div>
                    </div>
                    <div class="item">
                      <div class="txt">现任岗位</div>
                      <div class="con">
                        {{ $store.getters.user.post_name || '--' }}
                      </div>
                    </div>
                    <div class="item">
                      <div class="txt">入职时间</div>
                      <div class="con">
                        {{
                          $store.getters.user.join_date
                            ? this.$moment(
                                $store.getters.user.join_date
                              ).format('YYYY-MM-DD')
                            : '--'
                        }}
                      </div>
                    </div>
                    <div class="item">
                      <div class="txt">性别</div>
                      <div class="choose-box">
                        <el-radio-group v-model="form.gender">
                          <el-radio :label="1">男</el-radio>
                          <el-radio :label="0">女</el-radio>
                          <el-radio :label="-1">未设置</el-radio>
                        </el-radio-group>
                      </div>
                    </div>
                    <div class="item">
                      <div class="txt">手机号</div>
                      <div class="con">
                        <el-form-item prop="mobile" class="uc-mb0">
                          <el-input
                            v-model.trim="form.mobile"
                            autocompconste="off"
                            maxlength="11"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="item">
                      <div class="txt">邮箱</div>
                      <div class="con">
                        <el-form-item prop="email" class="uc-mb0">
                          <el-input
                            v-model.trim="form.email"
                            autocompconste="off"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <!-- <div class="item">
                    <div class="txt">个人简介</div>
                    <textarea
                      class="uc-textarea"
                      placeholder="请输入"
                      placeholder-class="uc-phColor"
                      style="height:140px;border:none;"
                    />
                  </div> -->
                  </div>
                </el-form>
                <!-- <div class="title">教育背景</div>
                <div class="list">
                  <div class="item">
                    <div class="txt">毕业院校</div>
                    <div class="con">
                      <input
                        type="text"
                        placeholder="请输入"
                        class="uc-input"
                      />
                    </div>
                  </div>
                  <div class="item">
                    <div class="txt">学历</div>
                    <div class="con">
                      <input
                        type="text"
                        placeholder="请输入"
                        class="uc-input"
                      />
                    </div>
                  </div>
                  <div class="item">
                    <div class="txt">专业</div>
                    <div class="con">
                      <input
                        type="text"
                        placeholder="请输入"
                        class="uc-input"
                      />
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <!-- /个人资料 -->
          <!-- 安全设置 -->
          <div class="row" v-show="tab == 'tab2'">
            <div class="form">
              <div class="title">帐号安全</div>
              <el-form :model="formPassword" :rules="rules" ref="formPassword">
                <div class="list">
                  <div class="item">
                    <div class="txt">登录帐号</div>
                    <div class="con">
                      <span class="uc-w100">{{
                        $store.getters.user.username
                      }}</span>
                    </div>
                  </div>
                  <div class="item">
                    <div class="txt">新密码</div>
                    <el-form-item prop="password" class="uc-mb0">
                      <el-input
                        type="password"
                        v-model.trim="formPassword.password"
                        autocompconste="off"
                        minlength="8"
                        maxlength="18"
                      ></el-input>
                    </el-form-item>
                    <div style="margin-left:10px;">
                      长度8-18位，必须由字母、数字组成，特殊字符只能是（!@#$%^&*），区分大小写
                    </div>
                  </div>
                  <div class="item">
                    <div class="txt">确认密码</div>
                    <div class="con">
                      <el-form-item prop="confirmPassword" class="uc-mb0">
                        <el-input
                          type="password"
                          v-model.trim="formPassword.confirmPassword"
                          autocompconste="off"
                          minlength="8"
                          maxlength="18"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
          <!-- /安全设置 -->
        </div>

        <div class="container">
          <div class="row">
            <div class="col-24">
              <div class="operate">
                <a
                  href="javascript:;"
                  @click="handleSubmitSure"
                  class="uc-btn blue"
                  >保存</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';
import { VueCropper } from 'vue-cropper';

export default {
  name: 'PersonalCenter',
  components: {
    TopHeader,
    BottomFooter,
    VueCropper,
  },
  data() {
    return {
      tab: 'tab1',
      adminUrl: process.env.VUE_APP_ADMINURL,
      headImg: this.$store.getters.user.avatar,
      form: {
        gender: -1,
        mobile: '',
        email: '',
      },
      formPassword: {
        password: '',
        confirmPassword: '',
      },
      dialogVisible: false,
      rules: {
        mobile: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur',
          },
          {
            required: true,
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: '请输入邮箱地址',
            trigger: 'blur',
          },
          {
            required: true,
            pattern: /^[a-z0-9A-Z]+[-|a-z0-9A-Z._]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-z]{2,}$/,
            message: '请输入正确的邮箱地址',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur',
          },
          {
            required: true,
            pattern: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]{8,18}$/,
            message: '密码不符合要求',
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: '请输入确认密码',
            trigger: 'blur',
          },
          {
            required: true,
            pattern: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]{8,18}$/,
            message: '密码不符合要求',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (this.formPassword.password !== value) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },

      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        size: 1,
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        info: true, // 裁剪框的大小信息
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 200, // 默认生成截图框高度
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        fixedBox: true, // 固定截图框大小 不允许改变
        canMove: true, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        high: true, // 是否按照设备的dpr 输出等比例图片
      },
      // 防止重复提交
      loading: false,
    };
  },
  created() {
    this.form.gender = this.$store.getters.user.gender;
    this.form.mobile = this.$store.getters.user.mobile;
    this.form.email = this.$store.getters.user.email;
  },
  methods: {
    // 上传按钮 限制图片大小
    changeUpload(file, fileList) {
      const imgType = ['image/jpeg', 'image/jpg', 'image/png'];
      const imgIndex = imgType.indexOf(file.raw.type);
      // console.log(file.raw.type);
      if (imgIndex === -1) {
        this.$message.error('上传文件只能是 png或jpg 格式!');
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 2MB!');
        return false;
      }
      this.fileinfo = file;

      this.$nextTick(() => {
        this.option.img = window.URL.createObjectURL(file.raw);
        this.dialogVisible = true;
      });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish(type) {
      if (type === 'blob') {
        // 获取截图的blob数据
        this.$refs.cropper.getCropBlob((data) => {
          this.loading = true;
          // 上传
          this.handleSubmitAvatar(data);
        });
      } else {
        // 获取截图的base64 数据
        this.$refs.cropper.getCropData((data) => {
          this.loading = true;
          // 上传
          this.handleSubmitAvatar(data);
        });
      }
    },
    imgLoad(msg) {
      console.log('imgLoad');
      console.log(msg);
    },
    // 预览
    realTime(data) {
      this.previews = data;
    },
    // 提交数据
    handleSubmitSure() {
      this.tab === 'tab1'
        ? this.handleSubmitInfo()
        : this.handleSubmitPassword();
    },
    // 提交基本信息
    handleSubmitInfo() {
      const submitData = {
        gender: this.form.gender,
        mobile: this.form.mobile,
        email: this.form.email,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 请求后台
          // console.log(submitData);
          this.updateUserInfo(submitData);
        }
      });
    },
    // 提交密码
    handleSubmitPassword() {
      const submitData = {
        Password: this.formPassword.password,
      };
      this.$refs.formPassword.validate((valid) => {
        if (valid) {
          // 请求后台
          // console.log(submitData);
          this.updateUserPassword(submitData);
          // 请求成功之后 清除输入框中的内容
          this.$nextTick(() => {
            // form对应你写的<el-form ref="form"></el-form>
            this.$refs.form.resetFields();
          });
        }
      });
    },
    // 更新头像
    handleSubmitAvatar(data) {
      const fileName = this.fileinfo.uid + this.fileinfo.name;
      // console.log(fileName);

      const formData = new FormData();
      formData.append('avatar', data, fileName); // 添加到请求体
      // 上传
      this.updateAvatar(formData);
    },
    // 修改个人信息
    async updateUserInfo(myInfo) {
      // 设置信息
      const data = localStorage.getItem('CurrentUser');
      const userData = JSON.parse(data);
      userData.gender = this.form.gender;
      userData.mobile = this.form.mobile;
      userData.email = this.form.email;
      localStorage.setItem('CurrentUser', JSON.stringify(userData));
      // 提交修改信息
      const response = await this.$api.user.updateUserInfo(myInfo);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.$store.dispatch('setUserInfo', userData);
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 修改密码
    async updateUserPassword(myPassword) {
      const response = await this.$api.user.updateUserPassword(myPassword);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 更新头像
    async updateAvatar(myAvatar) {
      const response = await this.$api.user.updateAvatar(myAvatar);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);

        this.loading = false;
        this.dialogVisible = false;

        // 设置信息
        const data = localStorage.getItem('CurrentUser');
        const userData = JSON.parse(data);
        userData.avatar = response.data.data;
        localStorage.setItem('CurrentUser', JSON.stringify(userData));

        // 设置头像回显
        this.headImg = userData.avatar;
      } else {
        this.$message.warning(response.data.message);
      }
    },
  },
};
</script>
